"use strict";var $export=require("./_export");$export($export.G+$export.W+$export.F*!require("./_typed").ABV,{DataView:require("./_typed-buffer").DataView});